import React from 'react'
import Vehicles from '../../../components/customer/vehicles/Vehicles'

const CustomerVehicles = () => {
    return <Vehicles />
}

export default CustomerVehicles
